module.exports = __webpack_public_path__ + "img/KinokoTable60.fd53f0a7.jpg";